var _defs, _path, _g, _g2, _path2, _g3, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g4, _path10, _g5, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _g6, _g7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPitchedRoofMajcoat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 643.96 404.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    x: 0.6,
    y: 357.09,
    width: 641.6,
    height: 22.2,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M642.21,357.09H.6v22.2h641.6v-22.2Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "d",
    x: -9.67,
    y: 5.61,
    width: 687.67,
    height: 77.49,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M642.21,5.61H.61v77.49h641.6V5.61Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -14.98,
    y: 215.76,
    width: 658.31,
    height: 12.77,
    fill: "none"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M643.33,59.02H.12v298.39h643.22V59.02Z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.45,357.69c-19.06,0-34.57-15.66-34.57-34.91,0-5.79,1.43-11.52,4.14-16.58.02-.03.04-.07.06-.1l13.74-27.14h0s.37-.73.37-.73c2.37-4.69,3.63-9.94,3.63-15.25,0-18.48-14.89-33.51-33.19-33.51s-33.19,15.03-33.19,33.51c0,5.09,1.1,9.99,3.28,14.54l15.55,30.74s.01.03.02.04c2.06,4.56,3.1,9.43,3.1,14.48,0,19.25-15.51,34.91-34.57,34.91-.38,0-.69-.31-.69-.7s.31-.7.69-.7c18.3,0,33.19-15.03,33.19-33.51,0-4.84-1-9.51-2.97-13.88l-15.56-30.77c-2.28-4.76-3.43-9.85-3.43-15.16,0-19.25,15.51-34.91,34.57-34.91s34.57,15.66,34.57,34.91c0,5.56-1.32,11.06-3.83,15.97l-.49.97s-.04.07-.06.1l-13.58,26.83s-.05.08-.08.13c-2.56,4.83-3.92,10.29-3.92,15.8,0,18.48,14.89,33.51,33.19,33.51.38,0,.69.31.69.7s-.31.7-.69.7h.03Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.08,357.69c-19.06,0-34.57-15.66-34.57-34.91,0-5.79,1.43-11.52,4.14-16.58.02-.03.04-.07.06-.1l13.74-27.14h0s.37-.73.37-.73c2.37-4.69,3.63-9.94,3.63-15.25,0-18.48-14.89-33.51-33.19-33.51s-33.19,15.03-33.19,33.51c0,5.09,1.1,9.99,3.28,14.54l15.55,30.74s.01.03.02.04c2.06,4.56,3.1,9.43,3.1,14.48,0,19.25-15.51,34.91-34.57,34.91-.38,0-.69-.31-.69-.7s.31-.7.69-.7c18.3,0,33.19-15.03,33.19-33.51,0-4.84-1-9.51-2.97-13.88l-15.56-30.77c-2.28-4.76-3.43-9.85-3.43-15.16,0-19.25,15.51-34.91,34.57-34.91s34.57,15.66,34.57,34.91c0,5.56-1.32,11.08-3.83,15.99l-.48.96s-.04.07-.06.1l-13.58,26.84s-.05.08-.08.13c-2.56,4.83-3.92,10.29-3.92,15.8,0,18.48,14.89,33.51,33.19,33.51.38,0,.69.31.69.7s-.31.7-.69.7h.03Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.7,357.69c-19.06,0-34.57-15.66-34.57-34.91,0-5.79,1.43-11.52,4.14-16.58.02-.03.04-.06.06-.1l13.74-27.14h0s.37-.73.37-.73c2.37-4.69,3.63-9.94,3.63-15.25,0-18.48-14.89-33.51-33.19-33.51s-33.19,15.03-33.19,33.51c0,5.09,1.1,9.99,3.28,14.54l15.55,30.74s.01.03.02.04c2.06,4.56,3.1,9.43,3.1,14.48,0,19.25-15.51,34.91-34.57,34.91-.38,0-.69-.31-.69-.7s.31-.7.69-.7c18.3,0,33.19-15.03,33.19-33.51,0-4.84-1-9.51-2.97-13.88l-15.56-30.77c-2.28-4.76-3.43-9.85-3.43-15.16,0-19.25,15.51-34.91,34.57-34.91s34.57,15.66,34.57,34.91c0,5.56-1.32,11.07-3.83,15.98l-.48.96s-.04.07-.06.1l-13.58,26.84s-.05.08-.08.12c-2.56,4.83-3.92,10.29-3.92,15.8,0,18.48,14.89,33.51,33.19,33.51.38,0,.69.31.69.7s-.31.7-.69.7h.01Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.33,357.7c-19.06,0-34.57-15.66-34.57-34.91,0-5.79,1.43-11.52,4.14-16.58.02-.03.04-.06.06-.1l13.74-27.15.36-.7c2.39-4.7,3.65-9.97,3.65-15.29,0-18.48-14.89-33.51-33.19-33.51s-33.19,15.03-33.19,33.51c0,5.09,1.1,9.99,3.28,14.54l15.55,30.74s.01.03.02.04c2.06,4.56,3.1,9.43,3.1,14.48,0,19.25-15.51,34.91-34.57,34.91-.38,0-.69-.31-.69-.7s.31-.7.69-.7c18.3,0,33.19-15.03,33.19-33.51,0-4.84-1-9.51-2.97-13.88l-15.56-30.77c-2.28-4.76-3.43-9.85-3.43-15.16,0-19.25,15.51-34.91,34.57-34.91s34.57,15.66,34.57,34.91c0,5.53-1.3,11-3.78,15.88,0,0,0,.01,0,.02l-.53,1.04s-.04.07-.06.1l-13.58,26.83s-.05.08-.08.12c-2.56,4.83-3.92,10.29-3.92,15.8,0,18.48,14.89,33.51,33.19,33.51.38,0,.69.31.69.7s-.31.7-.69.7v.02Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.96,357.7c-19.06,0-34.57-15.66-34.57-34.91,0-5.79,1.43-11.52,4.14-16.58.02-.03.04-.06.06-.1l13.74-27.15.36-.7c2.39-4.7,3.65-9.97,3.65-15.29,0-18.48-14.89-33.51-33.19-33.51s-33.19,15.03-33.19,33.51c0,5.09,1.1,9.99,3.28,14.54l15.55,30.74s.01.03.02.04c2.06,4.56,3.1,9.43,3.1,14.48,0,19.25-15.51,34.91-34.57,34.91-.38,0-.69-.31-.69-.7s.31-.7.69-.7c18.3,0,33.19-15.03,33.19-33.51,0-4.84-1-9.51-2.97-13.88l-15.56-30.77c-2.28-4.76-3.43-9.85-3.43-15.16,0-19.25,15.51-34.91,34.57-34.91s34.57,15.66,34.57,34.91c0,5.53-1.3,11-3.78,15.88,0,0,0,.01,0,.02l-.53,1.04s-.04.07-.06.1l-13.58,26.83s-.05.08-.08.12c-2.56,4.83-3.92,10.29-3.92,15.8,0,18.48,14.89,33.51,33.19,33.51.38,0,.69.31.69.7s-.31.7-.69.7v.02Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.59,357.7c-19.06,0-34.57-15.66-34.57-34.91,0-5.79,1.43-11.52,4.14-16.58.02-.03.04-.06.06-.1l13.74-27.15.36-.7c2.39-4.7,3.65-9.97,3.65-15.29,0-18.48-14.89-33.51-33.19-33.51s-33.19,15.03-33.19,33.51c0,5.09,1.1,9.99,3.28,14.54l15.55,30.76s.01.03.02.05c2.05,4.55,3.09,9.41,3.09,14.45,0,19.25-15.51,34.91-34.57,34.91-.38,0-.69-.31-.69-.7s.31-.7.69-.7c18.3,0,33.19-15.03,33.19-33.51,0-4.84-1-9.52-2.98-13.89l-15.55-30.75c-2.28-4.76-3.43-9.85-3.43-15.16,0-19.25,15.51-34.91,34.57-34.91s34.57,15.66,34.57,34.91c0,5.53-1.3,11-3.78,15.88,0,0,0,.01,0,.02l-.53,1.04s-.04.07-.06.1l-13.58,26.83s-.05.08-.08.12c-2.56,4.83-3.92,10.29-3.92,15.8,0,18.48,14.89,33.51,33.19,33.51.38,0,.69.31.69.7s-.31.7-.69.7v.02Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.22,357.7c-19.06,0-34.57-15.66-34.57-34.91,0-5.79,1.43-11.52,4.14-16.58.02-.03.04-.06.06-.1l13.74-27.15.36-.7c2.39-4.7,3.65-9.97,3.65-15.29,0-18.48-14.89-33.51-33.19-33.51s-33.19,15.03-33.19,33.51c0,5.09,1.1,9.99,3.28,14.54l15.55,30.74s.01.03.02.04c2.06,4.56,3.1,9.43,3.1,14.48,0,19.25-15.51,34.91-34.57,34.91-.38,0-.69-.31-.69-.7s.31-.7.69-.7c18.3,0,33.19-15.03,33.19-33.51,0-4.84-1-9.51-2.97-13.88l-15.56-30.77c-2.28-4.76-3.43-9.85-3.43-15.16,0-19.25,15.51-34.91,34.57-34.91s34.57,15.66,34.57,34.91c0,5.53-1.3,11-3.78,15.88,0,0,0,.01,0,.02l-.53,1.04s-.04.07-.06.1l-13.58,26.83s-.05.08-.08.12c-2.56,4.83-3.92,10.29-3.92,15.8,0,18.48,14.89,33.51,33.19,33.51.38,0,.69.31.69.7s-.31.7-.69.7v.02Z",
    fill: "#234c6f"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.45,209.81c-14.85,0-26.93-12.07-26.93-26.9,0-4.46,1.11-8.88,3.23-12.77.01-.03.04-.06.05-.08l10.63-20.78h0s.29-.55.29-.55c1.83-3.57,2.8-7.57,2.8-11.62,0-14.06-11.45-25.5-25.53-25.5s-25.53,11.44-25.53,25.5c0,3.88.85,7.6,2.53,11.07l12.04,23.55h0s0,.02.01.04c1.6,3.51,2.42,7.27,2.42,11.15,0,14.83-12.08,26.9-26.93,26.9-.38,0-.7-.31-.7-.7s.31-.7.7-.7c14.08,0,25.53-11.44,25.53-25.5,0-3.68-.77-7.23-2.29-10.56l-12.04-23.56c-1.77-3.67-2.67-7.6-2.67-11.68,0-14.83,12.08-26.9,26.93-26.9s26.93,12.07,26.93,26.9c0,4.26-1.01,8.48-2.95,12.25h0s-.41.8-.41.8c0,0-.04.06-.06.09l-10.51,20.54s-.04.08-.07.1c-1.97,3.67-3.01,7.82-3.01,12.01,0,14.06,11.45,25.5,25.53,25.5.38,0,.7.31.7.7s-.31.7-.7.7h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.4,209.81c-14.85,0-26.93-12.07-26.93-26.9,0-4.46,1.11-8.88,3.23-12.77.01-.03.03-.06.06-.08l10.63-20.78h0s.29-.55.29-.55c1.83-3.57,2.8-7.57,2.8-11.62,0-14.06-11.45-25.5-25.53-25.5s-25.53,11.44-25.53,25.5c0,3.88.85,7.6,2.53,11.07l12.04,23.55h0s0,.02.01.03c1.6,3.51,2.41,7.26,2.41,11.15,0,14.83-12.08,26.9-26.93,26.9-.38,0-.7-.31-.7-.7s.31-.7.7-.7c14.08,0,25.53-11.44,25.53-25.5,0-3.68-.77-7.24-2.29-10.56l-12.04-23.56c-1.77-3.67-2.67-7.6-2.67-11.68,0-14.83,12.08-26.9,26.93-26.9s26.93,12.07,26.93,26.9c0,4.26-1.01,8.48-2.95,12.24l-.41.8s-.03.06-.06.09l-10.5,20.54s-.04.08-.07.11c-1.97,3.67-3,7.82-3,12.01,0,14.06,11.45,25.5,25.53,25.5.38,0,.7.31.7.7s-.31.7-.7.7h-.01Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.33,209.81c-14.85,0-26.93-12.07-26.93-26.9,0-4.46,1.11-8.88,3.23-12.77.02-.03.04-.06.06-.08l10.63-20.78h0s.29-.55.29-.55c1.83-3.57,2.8-7.57,2.8-11.62,0-14.06-11.45-25.5-25.53-25.5s-25.53,11.44-25.53,25.5c0,3.88.85,7.6,2.52,11.07l12.04,23.55h0s0,.02.01.03c1.6,3.51,2.41,7.26,2.41,11.15,0,14.83-12.08,26.9-26.93,26.9-.38,0-.7-.31-.7-.7s.31-.7.7-.7c14.08,0,25.53-11.44,25.53-25.5,0-3.68-.77-7.24-2.29-10.56l-12.04-23.56c-1.77-3.67-2.67-7.6-2.67-11.68,0-14.83,12.08-26.9,26.93-26.9s26.93,12.07,26.93,26.9c0,4.26-1.01,8.48-2.95,12.24l-.41.81s-.03.06-.06.09l-10.51,20.54s-.04.08-.07.11c-1.97,3.67-3,7.82-3,12.01,0,14.06,11.45,25.5,25.53,25.5.39,0,.7.31.7.7s-.31.7-.7.7h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.28,209.81c-14.85,0-26.93-12.07-26.93-26.9,0-4.46,1.11-8.88,3.23-12.77.01-.03.03-.06.05-.08l10.63-20.78h0s.29-.55.29-.55c1.83-3.57,2.8-7.57,2.8-11.62,0-14.06-11.45-25.5-25.53-25.5s-25.53,11.44-25.53,25.5c0,3.88.85,7.6,2.53,11.07l12.04,23.55h0s0,.02.01.04c1.6,3.51,2.41,7.26,2.41,11.15,0,14.83-12.08,26.9-26.93,26.9-.39,0-.7-.31-.7-.7s.31-.7.7-.7c14.08,0,25.53-11.44,25.53-25.5,0-3.68-.77-7.24-2.29-10.56l-12.04-23.56c-1.77-3.67-2.67-7.6-2.67-11.68,0-14.83,12.08-26.9,26.93-26.9s26.93,12.07,26.93,26.9c0,4.26-1.01,8.48-2.95,12.25h0s-.41.8-.41.8c0,0-.03.06-.06.09l-10.51,20.54s-.04.08-.07.1c-1.97,3.67-3.01,7.83-3.01,12.01,0,14.06,11.45,25.5,25.53,25.5.38,0,.7.31.7.7s-.32.7-.7.7h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.22,209.81c-14.85,0-26.93-12.07-26.93-26.9,0-4.46,1.11-8.88,3.23-12.77.02-.03.04-.06.06-.08l10.63-20.78h0s.29-.55.29-.55c1.83-3.57,2.8-7.57,2.8-11.62,0-14.06-11.45-25.5-25.53-25.5s-25.53,11.44-25.53,25.5c0,3.88.85,7.6,2.52,11.07l12.04,23.55h0s0,.02.01.03c1.6,3.51,2.41,7.26,2.41,11.15,0,14.83-12.08,26.9-26.93,26.9-.38,0-.7-.31-.7-.7s.31-.7.7-.7c14.08,0,25.53-11.44,25.53-25.5,0-3.68-.77-7.24-2.29-10.56l-12.04-23.56c-1.77-3.67-2.67-7.6-2.67-11.68,0-14.83,12.08-26.9,26.93-26.9s26.93,12.07,26.93,26.9c0,4.26-1.01,8.48-2.95,12.24h0s-.41.8-.41.8c0,0-.03.06-.06.09l-10.51,20.54s-.04.08-.07.11c-1.97,3.67-3,7.82-3,12.01,0,14.06,11.45,25.5,25.53,25.5.39,0,.7.31.7.7s-.31.7-.7.7Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.16,209.81c-14.85,0-26.93-12.07-26.93-26.9,0-4.46,1.11-8.88,3.23-12.77.01-.03.03-.06.05-.08l10.63-20.78h0s.29-.55.29-.55c1.83-3.57,2.8-7.57,2.8-11.62,0-14.06-11.45-25.5-25.53-25.5s-25.53,11.44-25.53,25.5c0,3.88.85,7.6,2.52,11.07l12.04,23.55h0s0,.02.01.03c1.6,3.51,2.41,7.26,2.41,11.15,0,14.83-12.08,26.9-26.93,26.9-.39,0-.7-.31-.7-.7s.31-.7.7-.7c14.08,0,25.53-11.44,25.53-25.5,0-3.68-.77-7.24-2.29-10.56l-12.04-23.56c-1.77-3.67-2.67-7.6-2.67-11.68,0-14.83,12.08-26.9,26.93-26.9s26.93,12.07,26.93,26.9c0,4.26-1.01,8.48-2.95,12.24h0s-.41.8-.41.8c0,0-.03.06-.06.09l-10.51,20.54s-.04.08-.07.1c-1.97,3.67-3.01,7.82-3.01,12.01,0,14.06,11.45,25.5,25.53,25.5.39,0,.7.31.7.7s-.31.7-.7.7h.01Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.1,209.81c-14.85,0-26.93-12.07-26.93-26.9,0-4.46,1.11-8.88,3.23-12.77.01-.03.03-.06.05-.08l10.63-20.78h0s.29-.55.29-.55c1.83-3.57,2.8-7.57,2.8-11.62,0-14.06-11.45-25.5-25.53-25.5s-25.53,11.44-25.53,25.5c0,3.88.85,7.6,2.53,11.07l12.04,23.55h0s0,.02.01.04c1.6,3.51,2.41,7.26,2.41,11.15,0,14.83-12.08,26.9-26.93,26.9-.38,0-.7-.31-.7-.7s.31-.7.7-.7c14.08,0,25.53-11.44,25.53-25.5,0-3.68-.77-7.24-2.29-10.56l-12.04-23.56c-1.77-3.67-2.67-7.6-2.67-11.68,0-14.83,12.08-26.9,26.93-26.9s26.93,12.07,26.93,26.9c0,4.26-1.01,8.48-2.95,12.25h0s-.41.8-.41.8c0,0-.04.06-.06.09l-10.51,20.54s-.04.08-.07.1c-1.97,3.67-3,7.83-3,12.01,0,14.06,11.45,25.5,25.53,25.5.38,0,.7.31.7.7s-.31.7-.7.7h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.16,209.81c-14.85,0-26.93-12.07-26.93-26.9,0-4.46,1.11-8.88,3.23-12.77.01-.03.03-.06.05-.08l10.63-20.78h0s.29-.55.29-.55c1.83-3.57,2.8-7.57,2.8-11.62,0-14.06-11.45-25.5-25.53-25.5s-25.53,11.44-25.53,25.5c0,3.88.85,7.6,2.53,11.07l12.04,23.55h0s0,.02.01.04c1.6,3.51,2.42,7.27,2.42,11.15,0,14.83-12.08,26.9-26.93,26.9-.38,0-.7-.31-.7-.7s.31-.7.7-.7c14.08,0,25.53-11.44,25.53-25.5,0-3.68-.77-7.23-2.29-10.56l-12.04-23.56c-1.77-3.67-2.67-7.6-2.67-11.68,0-14.83,12.08-26.9,26.93-26.9s26.93,12.07,26.93,26.9c0,4.26-1.01,8.48-2.95,12.25h0s-.41.8-.41.8c0,0-.03.06-.06.09l-10.51,20.54s-.04.08-.07.1c-1.97,3.67-3.01,7.82-3.01,12.01,0,14.06,11.45,25.5,25.53,25.5.38,0,.7.31.7.7s-.31.7-.7.7h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.22,209.81c-14.85,0-26.93-12.07-26.93-26.9,0-4.46,1.11-8.88,3.23-12.77.01-.03.03-.06.06-.08l10.63-20.78h0s.29-.55.29-.55c1.83-3.57,2.8-7.57,2.8-11.62,0-14.06-11.45-25.5-25.53-25.5s-25.53,11.44-25.53,25.5c0,3.88.85,7.6,2.52,11.07l12.04,23.55h0s0,.02.01.03c1.6,3.51,2.41,7.26,2.41,11.15,0,14.83-12.08,26.9-26.93,26.9-.39,0-.7-.31-.7-.7s.31-.7.7-.7c14.08,0,25.53-11.44,25.53-25.5,0-3.68-.77-7.24-2.29-10.56l-12.04-23.56c-1.77-3.67-2.67-7.6-2.67-11.68,0-14.83,12.08-26.9,26.93-26.9s26.93,12.07,26.93,26.9c0,4.26-1.01,8.48-2.95,12.24h0s-.41.8-.41.8c0,0-.03.06-.06.09l-10.51,20.54s-.04.08-.07.11c-1.97,3.67-3,7.82-3,12.01,0,14.06,11.45,25.5,25.53,25.5.38,0,.7.31.7.7s-.32.7-.7.7Z",
    fill: "#234c6f"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M377.46,228.53h-111.46v128.88h111.46v-128.88Z",
    fill: "#fff"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M642.21,357.09H.6v22.2h641.6v-22.2Z",
    fill: "#234c6f"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M642.22,380.34H.6c-.58,0-1.05-.47-1.05-1.05v-22.2c0-.58.47-1.05,1.05-1.05h641.6c.58,0,1.05.47,1.05,1.05v22.2c0,.58-.47,1.05-1.05,1.05h0ZM1.66,378.24h639.51v-20.1H1.65v20.1h0Z",
    fill: "#234c6f"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M377.29,358.11h-110.87c-.62,0-1.11-.5-1.11-1.11v-127.84c0-.62.5-1.11,1.11-1.11h110.87c.62,0,1.11.5,1.11,1.11v127.84c0,.62-.5,1.11-1.11,1.11ZM267.54,355.88h108.64v-125.62h-108.64v125.62Z",
    fill: "#234c6f"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M377.29,357.69c-.2,0-.39-.08-.53-.24l-110.87-127.84c-.25-.29-.22-.73.07-.99.29-.25.73-.22.99.07l110.87,127.84c.25.29.22.73-.07.99-.13.11-.29.17-.46.17h0Z",
    fill: "#234c6f"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M265.37,357.49c-.16,0-.33-.06-.46-.18-.29-.25-.32-.7-.06-.98l111.92-127.63c.25-.29.7-.32.99-.06.29.25.32.7.06.99l-111.92,127.63c-.14.16-.33.24-.52.24Z",
    fill: "#234c6f"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M345.81,104.77h-50.33c-.44,0-.8-.36-.8-.8v-23.54c0-.44.36-.8.8-.8h50.33c.44,0,.8.36.8.8v23.54c0,.44-.36.8-.8.8ZM296.28,103.17h48.73v-21.94h-48.73v21.94Z",
    fill: "#234c6f"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M345.81,104.56c-.08,0-.18-.02-.25-.06l-50.33-23.54c-.3-.14-.43-.5-.29-.8.14-.3.5-.43.8-.29l50.33,23.54c.3.14.43.5.29.8-.11.22-.32.35-.55.35h0Z",
    fill: "#234c6f"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M295.48,104.56c-.22,0-.44-.13-.55-.35-.14-.3-.01-.66.29-.8l50.33-23.54c.3-.14.66-.01.8.29.14.3.01.66-.29.8l-50.33,23.54c-.08.04-.17.06-.25.06h0Z",
    fill: "#234c6f"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.67,362.04c-.18,0-.36-.07-.5-.2-.27-.27-.27-.71,0-.98l2.47-2.47c.27-.27.71-.27.99,0,.27.27.27.71,0,.99l-2.47,2.47c-.14.14-.31.2-.5.2h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5,368.86c-.19,0-.38-.08-.52-.23l-2.25-2.47c-.26-.29-.24-.73.04-.99.29-.26.73-.24.99.04l2.25,2.47c.26.29.24.73-.04.99-.13.13-.3.18-.47.18h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.78,370.09c-.24,0-.48-.13-.62-.36-.19-.34-.06-.76.27-.95l2.23-1.23c.34-.19.76-.06.95.27s.06.76-.27.95l-2.23,1.23c-.1.06-.22.09-.34.09Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.69,368.2h-3.49c-.38,0-.7-.31-.7-.7s.31-.7.7-.7h3.49c.38,0,.7.31.7.7s-.31.7-.7.7Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.54,361.89h-.03c-.38-.01-.69-.34-.66-.73l.15-3.33c.02-.38.36-.69.73-.66.38.01.69.34.66.73l-.15,3.33c-.01.38-.33.67-.7.67h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.43,364.55c-.06,0-.13,0-.2-.03l-2.45-.7c-.37-.1-.59-.5-.48-.87.1-.37.49-.59.87-.48l2.45.7c.37.11.59.5.48.87-.08.31-.37.5-.67.5h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4,365.33c-.18,0-.36-.07-.5-.2l-2.47-2.47c-.27-.27-.27-.71,0-.99.27-.27.71-.27.99,0l2.47,2.47c.27.27.27.71,0,.98-.14.14-.31.2-.5.2h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1,369.69c-.19,0-.38-.08-.52-.23-.26-.29-.24-.73.04-.99l2.47-2.25c.29-.26.73-.24.99.04.26.29.24.73-.04.99l-2.47,2.25c-.13.13-.3.18-.47.18h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1,362.2c-.24,0-.48-.13-.62-.36l-1.23-2.22c-.19-.34-.06-.76.27-.95.34-.19.76-.06.95.27l1.23,2.22c.19.34.06.76-.27.95-.1.06-.22.09-.34.09Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.88,362.04c-.18,0-.36-.07-.5-.2-.27-.27-.27-.71,0-.98l2.47-2.47c.27-.27.71-.27.99,0,.27.27.27.71,0,.99l-2.47,2.47c-.14.14-.31.2-.5.2h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.71,368.86c-.19,0-.38-.08-.52-.22l-2.26-2.47c-.26-.29-.24-.73.04-.99.29-.26.73-.24.99.04l2.26,2.47c.26.29.24.73-.04.99-.13.13-.3.18-.47.18Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.99,370.09c-.24,0-.48-.13-.62-.36-.19-.34-.06-.76.27-.95l2.23-1.23c.34-.19.76-.06.95.27.19.34.06.76-.27.95l-2.23,1.23c-.1.06-.22.09-.34.09Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9,368.2h-3.49c-.38,0-.7-.31-.7-.7s.31-.7.7-.7h3.49c.38,0,.7.31.7.7s-.31.7-.7.7Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.75,361.89h-.03c-.38-.01-.69-.34-.66-.73l.15-3.33c.01-.38.34-.69.73-.66.38.01.69.34.66.73l-.15,3.33c-.01.38-.33.67-.7.67h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.64,364.55c-.06,0-.13,0-.2-.03l-2.45-.7c-.37-.1-.59-.5-.48-.87.1-.37.49-.59.87-.48l2.45.7c.37.11.59.5.48.87-.08.31-.37.5-.67.5h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.61,365.33c-.18,0-.36-.07-.5-.2l-2.47-2.47c-.27-.27-.27-.71,0-.99.27-.27.71-.27.99,0l2.47,2.47c.27.27.27.71,0,.98-.14.14-.32.2-.5.2h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.31,369.69c-.19,0-.38-.08-.52-.23-.26-.29-.24-.73.04-.99l2.47-2.25c.29-.26.73-.24.99.04.26.29.24.73-.04.99l-2.47,2.25c-.13.13-.3.18-.47.18h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.31,362.2c-.24,0-.48-.13-.62-.36l-1.23-2.22c-.19-.34-.06-.76.27-.95.34-.19.76-.06.95.27l1.23,2.22c.19.34.06.76-.27.95-.1.06-.22.09-.34.09Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.09,362.04c-.18,0-.36-.07-.5-.2-.27-.27-.27-.71,0-.98l2.47-2.47c.27-.27.71-.27.99,0,.27.27.27.71,0,.99l-2.47,2.47c-.14.14-.32.2-.5.2h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.92,368.86c-.19,0-.38-.08-.52-.23l-2.25-2.47c-.26-.29-.24-.73.04-.99.29-.26.73-.24.99.04l2.25,2.47c.26.29.24.73-.04.99-.13.13-.3.18-.47.18h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.19,370.09c-.24,0-.48-.13-.62-.36-.19-.34-.06-.76.27-.95l2.23-1.23c.34-.19.76-.06.95.27.19.34.06.76-.27.95l-2.22,1.23c-.1.06-.22.09-.34.09Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.11,368.2h-3.49c-.38,0-.7-.31-.7-.7s.31-.7.7-.7h3.49c.39,0,.7.31.7.7s-.31.7-.7.7Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.96,361.89h-.03c-.39-.01-.69-.34-.67-.73l.15-3.33c.02-.38.35-.69.73-.66.38.01.69.34.66.73l-.15,3.33c-.01.38-.33.67-.7.67h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.85,364.55c-.06,0-.13,0-.2-.03l-2.45-.7c-.37-.1-.59-.5-.48-.87.1-.37.49-.59.87-.48l2.45.7c.37.11.59.5.48.87-.08.31-.37.5-.67.5h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.82,365.33c-.18,0-.36-.07-.5-.2l-2.47-2.47c-.27-.27-.27-.71,0-.99.27-.27.71-.27.99,0l2.47,2.47c.27.27.27.71,0,.98-.14.14-.32.2-.5.2h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.52,369.69c-.19,0-.38-.08-.52-.22-.26-.29-.24-.73.04-.98l2.47-2.25c.29-.26.73-.24.99.04.26.29.24.73-.04.98l-2.47,2.25c-.13.13-.3.18-.47.18Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.52,362.2c-.24,0-.48-.13-.62-.36l-1.23-2.22c-.19-.34-.06-.76.27-.95.34-.19.76-.06.95.27l1.23,2.22c.19.34.06.76-.27.95-.1.06-.22.09-.34.09Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.3,362.04c-.18,0-.36-.07-.5-.2-.27-.27-.27-.71,0-.98l2.47-2.47c.27-.27.71-.27.99,0,.27.27.27.71,0,.99l-2.47,2.47c-.14.14-.32.2-.5.2h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.13,368.86c-.19,0-.38-.08-.52-.23l-2.25-2.47c-.26-.29-.24-.73.04-.99.29-.26.73-.24.99.04l2.25,2.47c.26.29.24.73-.04.99-.13.13-.3.18-.47.18h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.4,370.09c-.24,0-.48-.13-.62-.36-.19-.34-.06-.76.27-.95l2.23-1.23c.34-.19.76-.06.95.27.19.34.06.76-.27.95l-2.22,1.23c-.1.06-.22.09-.34.09Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.32,368.2h-3.49c-.38,0-.7-.31-.7-.7s.31-.7.7-.7h3.49c.38,0,.7.31.7.7s-.31.7-.7.7Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.17,361.89h-.03c-.39-.01-.69-.34-.67-.73l.15-3.33c.02-.38.36-.69.73-.66.38.01.69.34.66.73l-.15,3.33c-.01.38-.33.67-.7.67h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.06,364.55c-.06,0-.13,0-.2-.03l-2.45-.7c-.37-.1-.59-.5-.48-.87.1-.37.49-.59.87-.48l2.45.7c.37.11.59.5.48.87-.08.31-.37.5-.67.5h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.03,365.33c-.18,0-.36-.07-.5-.2l-2.47-2.47c-.27-.27-.27-.71,0-.99.27-.27.71-.27.99,0l2.47,2.47c.27.27.27.71,0,.98-.14.14-.31.2-.5.2h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.73,369.69c-.19,0-.38-.08-.52-.23-.26-.29-.24-.73.04-.99l2.47-2.25c.29-.26.73-.24.99.04.26.29.24.73-.04.99l-2.47,2.25c-.13.13-.3.18-.47.18h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.73,362.2c-.24,0-.48-.13-.62-.36l-1.23-2.22c-.19-.34-.06-.76.27-.95.34-.19.76-.06.95.27l1.23,2.22c.19.34.06.76-.27.95-.1.06-.22.09-.34.09Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.1,362.04c-.18,0-.36-.07-.5-.2-.27-.27-.27-.71,0-.98l2.47-2.47c.27-.27.71-.27.99,0,.27.27.27.71,0,.99l-2.47,2.47c-.14.14-.31.2-.5.2h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.93,368.86c-.19,0-.38-.08-.52-.23l-2.25-2.47c-.26-.29-.24-.73.04-.99.29-.26.73-.24.99.04l2.25,2.47c.26.29.24.73-.04.99-.13.13-.3.18-.47.18h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.21,370.09c-.24,0-.48-.13-.62-.36-.19-.34-.06-.76.27-.95l2.23-1.23c.34-.19.76-.06.95.27.19.34.06.76-.27.95l-2.22,1.23c-.11.06-.22.09-.34.09Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.12,368.2h-3.49c-.38,0-.7-.31-.7-.7s.32-.7.7-.7h3.49c.39,0,.7.31.7.7s-.31.7-.7.7Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.97,361.89h-.03c-.39-.01-.69-.34-.67-.73l.15-3.33c.02-.38.34-.69.73-.66.38.01.69.34.66.73l-.15,3.33c-.01.38-.33.67-.7.67h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.87,364.55c-.06,0-.13,0-.2-.03l-2.45-.7c-.37-.1-.59-.5-.48-.87.1-.37.49-.59.87-.48l2.45.7c.37.11.59.5.48.87-.08.31-.37.5-.67.5h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.83,365.33c-.18,0-.36-.07-.5-.2l-2.47-2.47c-.27-.27-.27-.71,0-.99.27-.27.71-.27.99,0l2.47,2.47c.27.27.27.71,0,.98-.14.14-.32.2-.5.2h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.54,369.69c-.19,0-.38-.08-.52-.22-.26-.29-.24-.73.04-.98l2.47-2.25c.29-.26.73-.24.99.04.26.29.24.73-.04.98l-2.47,2.25c-.13.13-.3.18-.47.18Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.54,362.2c-.24,0-.48-.13-.62-.36l-1.23-2.22c-.19-.34-.06-.76.27-.95.34-.19.76-.06.95.27l1.23,2.22c.19.34.06.76-.27.95-.1.06-.22.09-.34.09Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.31,362.04c-.18,0-.36-.07-.5-.2-.27-.27-.27-.71,0-.98l2.47-2.47c.27-.27.71-.27.99,0,.27.27.27.71,0,.99l-2.47,2.47c-.14.14-.32.2-.5.2h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.14,368.86c-.19,0-.38-.08-.52-.23l-2.25-2.47c-.26-.29-.24-.73.04-.99.29-.26.73-.24.99.04l2.25,2.47c.26.29.24.73-.04.99-.13.13-.3.18-.47.18h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.41,370.09c-.24,0-.48-.13-.62-.36-.19-.34-.06-.76.27-.95l2.23-1.23c.34-.19.76-.06.95.27.19.34.06.76-.27.95l-2.22,1.23c-.1.06-.22.09-.34.09Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.33,368.2h-3.49c-.38,0-.7-.31-.7-.7s.31-.7.7-.7h3.49c.39,0,.7.31.7.7s-.31.7-.7.7Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.18,361.89h-.03c-.39-.01-.69-.34-.67-.73l.15-3.33c.02-.38.35-.69.73-.66.38.01.69.34.66.73l-.15,3.33c-.01.38-.33.67-.7.67h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.07,364.55c-.06,0-.13,0-.2-.03l-2.45-.7c-.37-.1-.59-.5-.48-.87.1-.37.49-.59.87-.48l2.45.7c.37.11.59.5.48.87-.08.31-.37.5-.67.5h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.04,365.33c-.18,0-.36-.07-.5-.2l-2.47-2.47c-.27-.27-.27-.71,0-.99.27-.27.71-.27.99,0l2.47,2.47c.27.27.27.71,0,.98-.14.14-.32.2-.5.2h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.75,369.69c-.19,0-.38-.08-.52-.22-.26-.29-.24-.73.04-.98l2.47-2.25c.29-.26.73-.24.99.04.26.29.24.73-.04.98l-2.47,2.25c-.13.13-.3.18-.47.18Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.75,362.2c-.24,0-.48-.13-.62-.36l-1.23-2.22c-.19-.34-.06-.76.27-.95.34-.19.76-.06.95.27l1.23,2.22c.19.34.06.76-.27.95-.1.06-.22.09-.34.09Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.52,362.04c-.18,0-.36-.07-.5-.2-.27-.27-.27-.71,0-.98l2.47-2.47c.27-.27.71-.27.99,0,.27.27.27.71,0,.99l-2.47,2.47c-.14.14-.32.2-.5.2h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.35,368.86c-.19,0-.38-.08-.52-.23l-2.25-2.47c-.26-.29-.24-.73.04-.99.29-.26.73-.24.99.04l2.25,2.47c.26.29.24.73-.04.99-.13.13-.3.18-.47.18h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.62,370.09c-.24,0-.48-.13-.62-.36-.19-.34-.06-.76.27-.95l2.23-1.23c.34-.19.76-.06.95.27.19.34.06.76-.27.95l-2.22,1.23c-.1.06-.22.09-.34.09Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.54,368.2h-3.49c-.38,0-.7-.31-.7-.7s.31-.7.7-.7h3.49c.38,0,.7.31.7.7s-.31.7-.7.7Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.38,361.89h-.03c-.38-.01-.69-.34-.66-.73l.15-3.33c.02-.38.36-.69.73-.66.38.01.69.34.66.73l-.15,3.33c-.01.38-.33.67-.7.67h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.28,364.55c-.06,0-.13,0-.2-.03l-2.45-.7c-.37-.1-.59-.5-.48-.87.1-.37.49-.59.87-.48l2.45.7c.37.11.59.5.48.87-.08.31-.37.5-.67.5h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.25,365.33c-.18,0-.36-.07-.5-.2l-2.47-2.47c-.27-.27-.27-.71,0-.99.27-.27.71-.27.99,0l2.47,2.47c.27.27.27.71,0,.98-.14.14-.32.2-.5.2h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.95,369.69c-.19,0-.38-.08-.52-.23-.26-.29-.24-.73.04-.99l2.47-2.25c.29-.26.73-.24.99.04.26.29.24.73-.04.99l-2.47,2.25c-.13.13-.3.18-.47.18h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.95,362.2c-.24,0-.48-.13-.62-.36l-1.23-2.22c-.19-.34-.06-.76.27-.95.34-.19.76-.06.95.27l1.23,2.22c.19.34.06.76-.27.95-.1.06-.22.09-.34.09Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.73,362.04c-.18,0-.36-.07-.5-.2-.27-.27-.27-.71,0-.98l2.47-2.47c.27-.27.71-.27.99,0s.27.71,0,.99l-2.47,2.47c-.14.14-.32.2-.5.2h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.56,368.86c-.19,0-.38-.08-.52-.23l-2.25-2.47c-.26-.29-.24-.73.04-.99.29-.26.73-.24.99.04l2.25,2.47c.26.29.24.73-.04.99-.13.13-.3.18-.47.18h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.83,370.09c-.24,0-.48-.13-.62-.36-.19-.34-.06-.76.27-.95l2.23-1.23c.34-.19.76-.06.95.27.19.34.06.76-.27.95l-2.22,1.23c-.1.06-.22.09-.34.09Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.75,368.2h-3.49c-.38,0-.7-.31-.7-.7s.31-.7.7-.7h3.49c.38,0,.7.31.7.7s-.31.7-.7.7Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.59,361.89h-.03c-.38-.01-.69-.34-.66-.73l.15-3.33c.02-.38.36-.69.73-.66.38.01.69.34.66.73l-.15,3.33c-.01.38-.33.67-.7.67h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.49,364.55c-.06,0-.13,0-.2-.03l-2.45-.7c-.37-.1-.59-.5-.48-.87.1-.37.49-.59.87-.48l2.45.7c.37.11.59.5.48.87-.08.31-.37.5-.67.5h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.46,365.33c-.18,0-.36-.07-.5-.2l-2.47-2.47c-.27-.27-.27-.71,0-.99s.71-.27.99,0l2.47,2.47c.27.27.27.71,0,.98-.14.14-.31.2-.5.2h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.16,369.69c-.19,0-.38-.08-.52-.23-.26-.29-.24-.73.04-.99l2.47-2.25c.29-.26.73-.24.99.04.26.29.24.73-.04.99l-2.47,2.25c-.13.13-.3.18-.47.18h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.16,362.2c-.24,0-.48-.13-.62-.36l-1.23-2.22c-.19-.34-.06-.76.27-.95.34-.19.76-.06.95.27l1.23,2.22c.19.34.06.76-.27.95-.1.06-.22.09-.34.09Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.86,362.04c-.18,0-.36-.07-.5-.2-.27-.27-.27-.71,0-.98l2.47-2.47c.27-.27.71-.27.99,0s.27.71,0,.99l-2.47,2.47c-.14.14-.31.2-.5.2h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.7,368.86c-.19,0-.38-.08-.52-.22l-2.26-2.47c-.26-.29-.24-.73.04-.99.29-.26.73-.24.99.04l2.26,2.47c.26.29.24.73-.04.99-.13.13-.3.18-.47.18Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.97,370.09c-.24,0-.48-.13-.62-.36-.19-.34-.06-.76.27-.95l2.22-1.23c.34-.19.76-.06.95.27s.06.76-.27.95l-2.22,1.23c-.11.06-.22.09-.34.09Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.88,368.2h-3.49c-.38,0-.7-.31-.7-.7s.32-.7.7-.7h3.49c.39,0,.7.31.7.7s-.31.7-.7.7Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.73,361.89h-.03c-.39-.01-.69-.34-.67-.73l.15-3.33c.01-.38.34-.69.73-.66.39.01.69.34.67.73l-.15,3.33c-.01.38-.33.67-.7.67h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.63,364.55c-.06,0-.13,0-.2-.03l-2.45-.7c-.37-.1-.59-.5-.48-.87.11-.37.49-.59.87-.48l2.45.7c.37.11.59.5.48.87-.08.31-.37.5-.67.5h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.6,365.33c-.18,0-.36-.07-.5-.2l-2.47-2.47c-.27-.27-.27-.71,0-.99.27-.27.71-.27.99,0l2.47,2.47c.27.27.27.71,0,.98-.14.14-.31.2-.5.2h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.3,369.69c-.19,0-.38-.08-.52-.23-.26-.29-.24-.73.04-.99l2.47-2.25c.29-.26.73-.24.99.04.26.29.24.73-.04.99l-2.47,2.25c-.13.13-.3.18-.47.18h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.3,362.2c-.24,0-.48-.13-.62-.36l-1.23-2.22c-.19-.34-.06-.76.27-.95.34-.19.76-.06.95.27l1.23,2.22c.19.34.06.76-.27.95-.11.06-.22.09-.34.09Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.07,362.04c-.18,0-.36-.07-.5-.2-.27-.27-.27-.71,0-.98l2.47-2.47c.27-.27.71-.27.99,0s.27.71,0,.99l-2.47,2.47c-.14.14-.31.2-.5.2h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.9,368.86c-.19,0-.38-.08-.52-.23l-2.25-2.47c-.26-.29-.24-.73.04-.99.29-.26.73-.24.99.04l2.25,2.47c.26.29.24.73-.04.99-.13.13-.3.18-.47.18h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.18,370.09c-.24,0-.48-.13-.62-.36-.19-.34-.06-.76.27-.95l2.23-1.23c.34-.19.76-.06.95.27s.06.76-.27.95l-2.22,1.23c-.11.06-.22.09-.34.09Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.09,368.2h-3.49c-.38,0-.7-.31-.7-.7s.32-.7.7-.7h3.49c.39,0,.7.31.7.7s-.31.7-.7.7Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.94,361.89h-.03c-.39-.01-.69-.34-.67-.73l.15-3.33c.02-.38.35-.69.73-.66.39.01.69.34.67.73l-.15,3.33c-.01.38-.33.67-.7.67h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.84,364.55c-.06,0-.13,0-.2-.03l-2.45-.7c-.37-.1-.59-.5-.48-.87.11-.37.49-.59.87-.48l2.45.7c.37.11.59.5.48.87-.08.31-.37.5-.67.5h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.8,365.33c-.18,0-.36-.07-.5-.2l-2.47-2.47c-.27-.27-.27-.71,0-.99.27-.27.71-.27.99,0l2.47,2.47c.27.27.27.71,0,.98-.14.14-.31.2-.5.2h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.51,369.69c-.19,0-.38-.08-.52-.23-.26-.29-.24-.73.04-.99l2.47-2.25c.29-.26.73-.24.99.04.26.29.24.73-.04.99l-2.47,2.25c-.13.13-.3.18-.47.18h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.51,362.2c-.24,0-.48-.13-.62-.36l-1.23-2.22c-.19-.34-.06-.76.27-.95.34-.19.76-.06.95.27l1.23,2.22c.19.34.06.76-.27.95-.1.06-.22.09-.34.09Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.28,362.04c-.18,0-.36-.07-.5-.2-.27-.27-.27-.71,0-.98l2.47-2.47c.27-.27.71-.27.99,0,.27.27.27.71,0,.99l-2.47,2.47c-.14.14-.31.2-.5.2h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.11,368.86c-.19,0-.38-.08-.52-.23l-2.25-2.47c-.26-.29-.24-.73.04-.99.29-.26.73-.24.99.04l2.25,2.47c.26.29.24.73-.04.99-.13.13-.3.18-.47.18h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.39,370.09c-.24,0-.48-.13-.62-.36-.19-.34-.06-.76.27-.95l2.23-1.23c.34-.19.76-.06.95.27.19.34.06.76-.27.95l-2.22,1.23c-.11.06-.22.09-.34.09Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.3,368.2h-3.49c-.38,0-.7-.31-.7-.7s.32-.7.7-.7h3.49c.39,0,.7.31.7.7s-.31.7-.7.7Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.15,361.89h-.03c-.39-.01-.69-.34-.67-.73l.15-3.33c.02-.38.36-.69.73-.66.38.01.68.34.66.73l-.15,3.33c-.02.38-.33.67-.7.67h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.05,364.55c-.06,0-.13,0-.2-.03l-2.45-.7c-.37-.1-.59-.5-.48-.87.1-.37.49-.59.87-.48l2.45.7c.37.11.59.5.48.87-.08.31-.37.5-.67.5h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.71,369.69c-.19,0-.38-.08-.52-.22-.26-.29-.24-.73.04-.98l2.47-2.25c.29-.26.73-.24.99.04.26.29.24.73-.04.98l-2.47,2.25c-.13.13-.3.18-.47.18Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.71,362.2c-.24,0-.48-.13-.62-.36l-1.23-2.22c-.19-.34-.06-.76.27-.95.34-.19.76-.06.95.27l1.23,2.22c.19.34.06.76-.27.95-.1.06-.22.09-.34.09Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6,375.91h-.03c-.38-.01-.69-.34-.66-.73l.15-3.33c.02-.38.35-.69.73-.66.38.01.69.34.66.73l-.15,3.33c-.01.38-.33.67-.7.67h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.81,375.91h-.03c-.39-.01-.69-.34-.67-.73l.15-3.33c.02-.38.36-.69.73-.66.38.01.69.34.66.73l-.15,3.33c-.01.38-.33.67-.7.67h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.02,375.91h-.03c-.39-.01-.69-.34-.67-.73l.15-3.33c.02-.38.34-.69.73-.66.38.01.69.34.66.73l-.15,3.33c-.01.38-.33.67-.7.67h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.82,375.91h-.03c-.39-.01-.69-.34-.67-.73l.15-3.33c.02-.38.35-.69.73-.66.39.01.69.34.67.73l-.15,3.33c-.01.38-.33.67-.7.67h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.03,375.91h-.03c-.39-.01-.69-.34-.67-.73l.15-3.33c.02-.38.36-.69.73-.66.38.01.69.34.66.73l-.15,3.33c-.01.38-.33.67-.7.67h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.24,375.91h-.03c-.39-.01-.69-.34-.67-.73l.15-3.33c.02-.38.34-.69.73-.66.38.01.69.34.66.73l-.15,3.33c-.01.38-.33.67-.7.67h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.45,375.91h-.03c-.39-.01-.69-.34-.67-.73l.15-3.33c.02-.38.35-.69.73-.66.38.01.69.34.66.73l-.15,3.33c-.01.38-.33.67-.7.67h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.59,375.91h-.04c-.38-.01-.69-.34-.66-.73l.15-3.33c.02-.38.36-.69.73-.66.39.01.69.34.67.73l-.15,3.33c-.01.38-.33.67-.7.67h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.8,375.91h-.04c-.38-.01-.69-.34-.66-.73l.15-3.33c.02-.38.36-.69.73-.66.39.01.69.34.67.73l-.15,3.33c-.01.38-.33.67-.7.67h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.01,375.91h-.03c-.39-.01-.69-.34-.67-.73l.15-3.33c.02-.38.34-.69.73-.66.39.01.69.34.67.73l-.15,3.33c-.01.38-.33.67-.7.67h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.39,375.91h-.03c-.38-.01-.69-.34-.66-.73l.15-3.33c.02-.38.35-.69.73-.66.38.01.69.34.66.73l-.15,3.33c-.01.38-.33.67-.7.67h0Z",
    fill: "#234c6f"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M642.22,81.47H.6c-.58,0-1.05-.47-1.05-1.05v-20.19c0-.58.47-1.05,1.05-1.05h641.6c.58,0,1.05.47,1.05,1.05v20.19c0,.58-.47,1.05-1.05,1.05h0ZM1.66,79.37h639.51v-18.09H1.65v18.09h0Z",
    fill: "#234c6f"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.69,47.87c-.08,0-.17,0-.25-.03-.56-.14-.9-.71-.76-1.27.78-3.12.9-6.25.38-9.33-.91-5.35-3.77-10.2-8.25-14.03-7.93-6.79-17.98-6.25-22.8-5.98-7.28.39-13.79,2.42-19.36,6.04-3.36,2.18-5.23,4.2-7.21,6.34-2.11,2.28-4.28,4.63-8.34,7.27-4.21,2.73-8.89,4.76-13.95,6.04v.91c0,.58-.47,1.05-1.05,1.05h-10.87c-.58,0-1.05-.47-1.05-1.05v-.68H19.92v.68c0,.58-.47,1.05-1.05,1.05h-10.82c-.58,0-1.05-.47-1.05-1.05v-.68H-7.67c-.58,0-1.05-.47-1.05-1.05s.47-1.05,1.05-1.05h15.72c.58,0,1.05.47,1.05,1.05v.68h8.72v-.68c0-.58.47-1.05,1.05-1.05h47.35c.58,0,1.05.47,1.05,1.05v.68h8.77v-.68c0-.49.34-.91.81-1.02,5.13-1.2,9.87-3.21,14.1-5.95,3.83-2.49,5.93-4.75,7.95-6.93,1.98-2.14,4.02-4.35,7.61-6.67,5.88-3.82,12.74-5.97,20.4-6.38,5.09-.27,15.7-.85,24.27,6.49,4.86,4.15,7.96,9.43,8.95,15.27.57,3.36.43,6.79-.41,10.19-.12.48-.55.8-1.02.8h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.01,50.74c-.38,0-.73-.2-.91-.53l-1.33-2.35h-3.37c-.58,0-1.05-.47-1.05-1.05s.47-1.05,1.05-1.05h3.98c.38,0,.73.2.91.53l1.33,2.35h68.89c5.7-.24,11.15-1.63,16.16-4.1,5.61-2.77,9.15-6.21,11.06-8.06,3.67-3.56,6.77-7.67,9.19-12.19.27-.51.91-.71,1.42-.43.51.27.71.91.43,1.42-2.53,4.72-5.75,8.99-9.58,12.7-1.99,1.93-5.68,5.51-11.59,8.43-5.27,2.6-11,4.05-17.04,4.32H-3.01Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.93,61.27c-.73,0-1.46-.01-2.18-.04H-3.73c-.58,0-1.05-.47-1.05-1.05s.47-1.05,1.05-1.05H60.78c5.98.22,11.89-.48,17.6-2.09,6.66-1.87,11.46-4.53,13.21-5.58,7.84-4.72,13.95-11.4,16.32-14.6,1.01-1.36,1.9-2.36,3.69-4.35,2.37-2.65,3.18-3.28,4.28-3.73,2.83-1.17,5.57-.24,6.09-.03,3.75,1.43,6.05,5.02,6,9.36,0,.57-.48,1.03-1.05,1.03h-.01c-.58,0-1.04-.48-1.04-1.06.03-3.45-1.75-6.27-4.65-7.37-.24-.09-2.4-.87-4.54.01-.65.27-1.21.62-3.51,3.18-1.76,1.96-2.63,2.94-3.58,4.21-2.46,3.33-8.8,10.26-16.93,15.15-1.83,1.1-6.81,3.86-13.73,5.81-5.22,1.47-10.6,2.2-16.02,2.2h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.57,47.87h-12.44c-.47,0-.88-.31-1.01-.76,0,0-1.9-6.73-2.9-10.29-1.01-3.62-2.37-5.84-3.8-6.25-1.75-.5-4.22.32-4.94,1.31-.62.85-1.25,4.21-1.5,6.32-.07.57-.59.99-1.17.92-.57-.07-.99-.59-.92-1.17.11-.94.73-5.71,1.88-7.3,1.3-1.81,4.74-2.81,7.22-2.1,2.22.64,3.99,3.22,5.25,7.69.8,2.82,2.15,7.66,2.69,9.52h11.65c.58,0,1.05.47,1.05,1.05s-.47,1.05-1.05,1.05h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.38,61.38c-.1,0-.19-.01-.29-.04-.56-.16-.88-.73-.73-1.29.19-.66,1.86-6.5,2.92-8.21,1.25-2.02,4.07-2.88,5.98-2.52,1.49.28,3.28,1.73,4.86,3,.29.23.55.45.81.64l.29.23c1.78,1.4,6.51,5.14,11.27,5.57,5.27.48,20.44.38,20.59.38.57,0,1.04.46,1.05,1.04,0,.58-.46,1.05-1.04,1.06-.63,0-15.43.1-20.8-.39-5.38-.49-10.47-4.5-12.38-6.01l-.28-.22c-.26-.2-.54-.43-.83-.66-1.18-.95-2.96-2.39-3.93-2.57-1.06-.2-3.02.3-3.8,1.57-.76,1.24-2.2,5.96-2.68,7.67-.13.46-.55.76-1.01.76Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.78,70.2h-34.81c-.46,0-.87-.3-1-.73l-2.73-8.76c-.17-.55.14-1.14.69-1.31.55-.17,1.14.14,1.32.69l2.5,8.02h33.26l2.41-8.07c.17-.55.75-.87,1.31-.71.55.17.87.75.71,1.31l-2.62,8.83c-.13.45-.54.75-1.01.75h-.02Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.68,61.23h-42.53c-.52,0-.97-.38-1.04-.9l-2.88-20.38c-.34-2.42.15-4.82,1.38-6.74,1.37-2.13,2.98-2.61,4.09-2.65,3.36-.1,4.28,2.01,4.51,2.91.15.59.32,1.06.52,1.47.67,1.31,1.12,1.89,1.29,2.05,1.08.27,7.05.64,8.23.24.47-.16,1.04-2.01,1.27-2.8.33-1.08.57-1.87,1.04-2.32.87-.85,1.84-1.57,4.17-1.24,2.33.33,4.09,4.47,4.58,5.73.21.54-.06,1.15-.6,1.36-.54.21-1.15-.06-1.36-.6-.77-1.99-2.18-4.3-2.92-4.41-1.5-.22-1.84.12-2.41.67-.1.15-.33.89-.49,1.43-.52,1.71-1.11,3.65-2.59,4.16-1.81.63-8.65.1-9.68-.26-.52-.18-1.18-.68-2.4-3.06-.28-.54-.5-1.15-.69-1.91-.23-.92-1.04-1.37-2.42-1.33-.88.03-1.69.59-2.39,1.68-.96,1.49-1.34,3.38-1.06,5.31l2.74,19.48h41.63c.58,0,1.05.47,1.05,1.05s-.47,1.05-1.05,1.05h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.42,70.2h-7.64c-.44,0-.84-.28-.99-.69l-2.93-8.19c-.2-.55.09-1.15.64-1.34.55-.2,1.15.09,1.34.64l2.69,7.5h6.91c6.47,0,12.81-1.77,18.34-5.12l.87-.52c3.76-2.27,6.93-5.26,9.43-8.86l9.95-14.37c.33-.48.98-.59,1.46-.27.48.33.59.99.27,1.46l-9.95,14.37c-2.67,3.85-6.05,7.04-10.07,9.46l-.87.52c-5.86,3.54-12.58,5.42-19.43,5.42h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.23,61.27h-29.05c-.58,0-1.05-.47-1.05-1.05s.47-1.05,1.05-1.05h29.05c.58,0,1.05.47,1.05,1.05s-.47,1.05-1.05,1.05Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.65,47.87c-.08,0-.17,0-.25-.03-.56-.14-.9-.71-.76-1.27.78-3.12.9-6.25.38-9.33-.91-5.35-3.76-10.2-8.25-14.03-7.93-6.79-17.98-6.25-22.8-5.98-7.28.39-13.79,2.42-19.36,6.04-3.36,2.18-5.23,4.2-7.21,6.34-2.11,2.28-4.29,4.63-8.34,7.27-4.21,2.73-8.89,4.76-13.95,6.04v.91c0,.58-.47,1.05-1.05,1.05h-10.87c-.58,0-1.05-.47-1.05-1.05v-.68h-45.25v.68c0,.58-.47,1.05-1.05,1.05h-10.82c-.58,0-1.05-.47-1.05-1.05v-.68h-14.67c-.58,0-1.05-.47-1.05-1.05s.47-1.05,1.05-1.05h15.72c.58,0,1.05.47,1.05,1.05v.68h8.72v-.68c0-.58.47-1.05,1.05-1.05h47.35c.58,0,1.05.47,1.05,1.05v.68h8.78v-.68c0-.49.34-.91.81-1.02,5.14-1.2,9.88-3.21,14.1-5.95,3.84-2.49,5.93-4.75,7.95-6.93,1.98-2.14,4.02-4.35,7.61-6.67,5.89-3.82,12.74-5.97,20.4-6.38,5.09-.27,15.7-.85,24.27,6.49,4.86,4.15,7.96,9.43,8.95,15.27.57,3.36.43,6.79-.41,10.19-.12.48-.55.8-1.01.8h-.01Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.95,50.74c-.38,0-.73-.2-.91-.53l-1.33-2.34h-3.37c-.58,0-1.05-.47-1.05-1.05s.47-1.05,1.05-1.05h3.99c.38,0,.73.2.91.53l1.33,2.34h68.89c5.7-.24,11.15-1.63,16.16-4.1,5.61-2.77,9.15-6.21,11.06-8.06,3.67-3.56,6.77-7.67,9.19-12.19.27-.51.91-.71,1.42-.43.51.27.71.91.43,1.42-2.53,4.72-5.75,8.99-9.58,12.7-1.99,1.93-5.68,5.51-11.59,8.43-5.27,2.6-11,4.05-17.04,4.32h-69.55Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.89,61.27c-.73,0-1.46-.01-2.18-.04h-64.47c-.58,0-1.05-.47-1.05-1.05s.47-1.05,1.05-1.05h64.51c5.98.22,11.9-.48,17.6-2.09,6.66-1.87,11.45-4.53,13.21-5.58,7.84-4.72,13.95-11.4,16.32-14.6,1.01-1.36,1.91-2.36,3.7-4.36,2.37-2.63,3.18-3.26,4.27-3.72,2.83-1.17,5.57-.24,6.09-.03,3.75,1.43,6.05,5.01,6,9.36,0,.58-.47,1.05-1.06,1.03-.58,0-1.04-.48-1.03-1.06.03-3.44-1.75-6.27-4.65-7.37-.24-.09-2.4-.87-4.54.01-.65.27-1.21.61-3.51,3.18-1.75,1.95-2.63,2.93-3.58,4.21-2.46,3.33-8.8,10.26-16.93,15.15-1.83,1.1-6.82,3.86-13.73,5.81-5.22,1.47-10.6,2.2-16.02,2.2h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.52,47.87h-12.44c-.47,0-.88-.31-1.01-.76,0,0-1.9-6.73-2.9-10.29-1.02-3.62-2.37-5.84-3.8-6.25-1.75-.5-4.22.32-4.94,1.31-.62.85-1.24,4.21-1.5,6.32-.07.57-.59.99-1.17.92-.57-.07-.99-.59-.92-1.17.11-.94.73-5.71,1.88-7.3,1.3-1.81,4.74-2.81,7.22-2.1,2.25.64,3.97,3.16,5.25,7.69.8,2.82,2.15,7.66,2.69,9.52h11.65c.58,0,1.05.47,1.05,1.05s-.47,1.05-1.05,1.05h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.34,61.38c-.1,0-.19-.01-.29-.04-.56-.16-.88-.73-.73-1.29.19-.66,1.86-6.5,2.92-8.21,1.25-2.02,4.08-2.88,5.97-2.52,1.49.28,3.28,1.73,4.86,3,.29.23.56.45.8.64l.29.23c1.78,1.4,6.51,5.14,11.27,5.57,5.27.48,20.44.38,20.59.38.59-.03,1.05.46,1.06,1.04,0,.58-.46,1.05-1.04,1.06-.63,0-15.43.1-20.8-.39-5.38-.49-10.47-4.5-12.38-6.01l-.28-.22c-.26-.2-.54-.43-.83-.66-1.18-.95-2.96-2.39-3.93-2.57-1.06-.2-3.02.3-3.8,1.57-.76,1.24-2.2,5.96-2.68,7.67-.13.46-.55.76-1.01.76h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.74,70.2h-34.81c-.46,0-.87-.3-1-.73l-2.73-8.76c-.18-.55.14-1.14.69-1.31.55-.17,1.14.14,1.32.69l2.5,8.02h33.26l2.41-8.07c.17-.55.75-.87,1.31-.71.55.17.88.75.71,1.31l-2.63,8.83c-.13.45-.54.75-1.01.75h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.64,61.23h-42.54c-.52,0-.96-.38-1.04-.9l-2.88-20.38c-.34-2.42.15-4.81,1.38-6.73,1.37-2.13,2.98-2.62,4.09-2.65,3.41-.1,4.29,2.01,4.51,2.91.15.59.32,1.06.52,1.47.77,1.5,1.18,1.95,1.29,2.05,1.08.27,7.05.64,8.23.24.47-.16,1.03-2.01,1.27-2.8.33-1.08.57-1.87,1.04-2.33.87-.85,1.84-1.57,4.17-1.24,2.33.33,4.09,4.47,4.58,5.73.21.54-.06,1.15-.6,1.36-.54.21-1.15-.06-1.36-.6-.77-1.99-2.18-4.3-2.92-4.41-1.5-.21-1.84.12-2.41.67-.11.15-.33.89-.49,1.43-.52,1.71-1.11,3.65-2.59,4.17-1.81.63-8.65.1-9.68-.26-.52-.18-1.17-.68-2.4-3.06-.28-.55-.5-1.15-.69-1.91-.23-.92-1.05-1.37-2.42-1.33-.88.03-1.69.59-2.39,1.68-.96,1.5-1.34,3.38-1.06,5.3l2.74,19.48h41.63c.58,0,1.05.47,1.05,1.05s-.47,1.05-1.05,1.05h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.37,70.2h-7.65c-.44,0-.84-.28-.99-.69l-2.93-8.19c-.2-.55.09-1.15.64-1.34.55-.2,1.15.09,1.34.64l2.69,7.5h6.91c6.46,0,12.81-1.77,18.34-5.12l.87-.52c3.76-2.27,6.93-5.26,9.42-8.86l9.95-14.37c.33-.48.99-.59,1.46-.27.47.33.59.99.27,1.46l-9.95,14.37c-2.67,3.85-6.05,7.04-10.07,9.46l-.87.52c-5.86,3.54-12.58,5.42-19.43,5.42h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.18,61.27h-29.05c-.58,0-1.05-.47-1.05-1.05s.47-1.05,1.05-1.05h29.05c.58,0,1.05.47,1.05,1.05s-.47,1.05-1.05,1.05Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.61,47.87c-.08,0-.17,0-.25-.03-.56-.14-.9-.71-.76-1.27.78-3.12.9-6.25.38-9.33-.91-5.35-3.76-10.2-8.25-14.03-7.93-6.79-17.97-6.25-22.8-5.98-7.28.39-13.79,2.42-19.36,6.04-3.36,2.18-5.23,4.2-7.21,6.34-2.11,2.28-4.28,4.63-8.34,7.27-4.21,2.73-8.89,4.76-13.95,6.04v.91c0,.58-.47,1.05-1.05,1.05h-10.87c-.58,0-1.05-.47-1.05-1.05v-.68h-45.25v.68c0,.58-.47,1.05-1.05,1.05h-10.82c-.58,0-1.05-.47-1.05-1.05v-.68h-14.67c-.58,0-1.05-.47-1.05-1.05s.47-1.05,1.05-1.05h15.72c.58,0,1.05.47,1.05,1.05v.68h8.72v-.68c0-.58.47-1.05,1.05-1.05h47.35c.58,0,1.05.47,1.05,1.05v.68h8.77v-.68c0-.49.34-.91.81-1.02,5.13-1.2,9.87-3.21,14.1-5.95,3.83-2.49,5.93-4.75,7.95-6.93,1.98-2.14,4.02-4.35,7.61-6.67,5.88-3.82,12.74-5.97,20.4-6.38,5.09-.27,15.7-.85,24.27,6.49,4.86,4.15,7.96,9.43,8.95,15.27.57,3.36.43,6.79-.41,10.19-.12.48-.55.8-1.02.8h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.91,50.74c-.38,0-.73-.2-.91-.53l-1.33-2.35h-3.37c-.58,0-1.05-.47-1.05-1.05s.47-1.05,1.05-1.05h3.98c.38,0,.73.2.91.53l1.33,2.35h68.89c5.7-.24,11.15-1.63,16.16-4.1,5.61-2.77,9.15-6.21,11.06-8.06,3.67-3.56,6.77-7.67,9.19-12.19.27-.51.91-.71,1.42-.43.51.27.71.91.43,1.42-2.53,4.72-5.75,8.99-9.58,12.7-1.99,1.93-5.68,5.51-11.59,8.43-5.27,2.6-11,4.05-17.04,4.32h-69.55,0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.84,61.27c-.73,0-1.45-.01-2.18-.04h-64.47c-.58,0-1.05-.47-1.05-1.05s.47-1.05,1.05-1.05h64.51c5.98.22,11.89-.48,17.6-2.09,6.66-1.87,11.46-4.53,13.21-5.58,7.84-4.72,13.95-11.4,16.32-14.6,1.01-1.36,1.9-2.36,3.69-4.35,2.37-2.65,3.18-3.28,4.28-3.73,2.83-1.17,5.57-.24,6.09-.03,3.75,1.43,6.05,5.02,6,9.36,0,.58-.51,1.05-1.06,1.03-.58,0-1.04-.48-1.04-1.06.03-3.45-1.75-6.27-4.65-7.37-.24-.09-2.4-.87-4.54.01-.65.27-1.21.62-3.51,3.18-1.76,1.96-2.63,2.94-3.58,4.21-2.46,3.33-8.8,10.26-16.93,15.15-1.83,1.1-6.82,3.86-13.73,5.81-5.22,1.47-10.6,2.2-16.02,2.2h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.48,47.87h-12.44c-.47,0-.88-.31-1.01-.76,0,0-1.9-6.73-2.9-10.29-1.01-3.62-2.37-5.84-3.8-6.25-1.75-.5-4.22.32-4.94,1.31-.62.85-1.25,4.21-1.5,6.32-.07.57-.59.99-1.17.92-.57-.07-.99-.59-.92-1.17.11-.94.73-5.71,1.88-7.3,1.3-1.81,4.74-2.81,7.22-2.1,2.22.64,3.99,3.22,5.25,7.69.8,2.82,2.16,7.66,2.69,9.52h11.65c.58,0,1.05.47,1.05,1.05s-.47,1.05-1.05,1.05h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.29,61.38c-.1,0-.19-.01-.29-.04-.56-.16-.88-.73-.73-1.29.19-.66,1.86-6.5,2.92-8.21,1.25-2.02,4.08-2.88,5.98-2.52,1.49.28,3.28,1.73,4.86,3,.29.23.55.45.81.64l.29.23c1.78,1.4,6.51,5.14,11.27,5.57,5.27.48,20.44.38,20.59.38.57,0,1.04.46,1.05,1.04,0,.58-.46,1.05-1.04,1.06-.63,0-15.43.1-20.8-.39-5.38-.49-10.47-4.5-12.38-6.01l-.28-.22c-.26-.2-.54-.43-.83-.66-1.18-.95-2.96-2.39-3.93-2.57-1.06-.2-3.02.3-3.8,1.57-.76,1.24-2.2,5.96-2.68,7.67-.13.46-.55.76-1.01.76Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.69,70.2h-34.81c-.46,0-.87-.3-1-.73l-2.73-8.76c-.17-.55.14-1.14.69-1.31.55-.17,1.14.14,1.32.69l2.5,8.02h33.26l2.41-8.07c.17-.55.75-.87,1.31-.71.56.17.87.75.71,1.31l-2.62,8.83c-.13.45-.54.75-1.01.75h-.01Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.6,61.23h-42.53c-.52,0-.97-.38-1.04-.9l-2.88-20.38c-.34-2.42.15-4.82,1.38-6.73,1.37-2.13,2.98-2.61,4.09-2.65,3.37-.1,4.28,2.01,4.51,2.91.15.59.32,1.06.52,1.47.67,1.31,1.12,1.89,1.29,2.05,1.08.27,7.05.64,8.23.24.47-.16,1.04-2.01,1.27-2.8.33-1.08.57-1.87,1.04-2.32.87-.85,1.84-1.57,4.17-1.24,2.33.33,4.09,4.47,4.58,5.73.21.54-.06,1.15-.6,1.36-.54.21-1.15-.06-1.36-.6-.77-1.99-2.18-4.3-2.92-4.41-1.5-.22-1.84.12-2.41.67-.1.15-.33.89-.49,1.43-.52,1.71-1.11,3.65-2.59,4.17-1.81.63-8.65.1-9.68-.26-.52-.18-1.18-.68-2.4-3.06-.28-.55-.5-1.15-.69-1.91-.23-.92-1.05-1.37-2.42-1.33-.88.03-1.69.59-2.39,1.68-.96,1.5-1.34,3.38-1.06,5.3l2.74,19.48h41.63c.58,0,1.05.47,1.05,1.05s-.47,1.05-1.05,1.05h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.33,70.2h-7.64c-.44,0-.84-.28-.99-.69l-2.93-8.19c-.2-.55.09-1.15.64-1.34.55-.2,1.15.09,1.34.64l2.69,7.5h6.91c6.47,0,12.81-1.77,18.34-5.12l.87-.52c3.76-2.27,6.93-5.26,9.43-8.86l9.95-14.37c.33-.48.99-.59,1.46-.27s.59.99.27,1.46l-9.95,14.37c-2.67,3.85-6.05,7.04-10.07,9.46l-.87.52c-5.86,3.54-12.58,5.42-19.43,5.42h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.14,61.27h-29.05c-.58,0-1.05-.47-1.05-1.05s.47-1.05,1.05-1.05h29.05c.58,0,1.05.47,1.05,1.05s-.47,1.05-1.05,1.05Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.56,47.87c-.08,0-.17,0-.25-.03-.56-.14-.9-.71-.76-1.27.78-3.12.9-6.25.38-9.33-.91-5.35-3.76-10.2-8.25-14.03-7.93-6.79-17.97-6.25-22.8-5.98-7.28.39-13.79,2.42-19.36,6.04-3.36,2.18-5.23,4.2-7.21,6.34-2.11,2.28-4.29,4.63-8.34,7.27-4.21,2.73-8.89,4.76-13.95,6.04v.91c0,.58-.47,1.05-1.05,1.05h-10.87c-.58,0-1.05-.47-1.05-1.05v-.68h-45.25v.68c0,.58-.47,1.05-1.05,1.05h-10.82c-.58,0-1.05-.47-1.05-1.05v-.68h-14.67c-.58,0-1.05-.47-1.05-1.05s.47-1.05,1.05-1.05h15.72c.58,0,1.05.47,1.05,1.05v.68h8.72v-.68c0-.58.47-1.05,1.05-1.05h47.35c.58,0,1.05.47,1.05,1.05v.68h8.78v-.68c0-.49.34-.91.81-1.02,5.14-1.2,9.88-3.21,14.1-5.95,3.84-2.49,5.93-4.75,7.95-6.93,1.98-2.14,4.02-4.35,7.6-6.67,5.89-3.82,12.74-5.97,20.4-6.38,5.09-.27,15.7-.85,24.27,6.49,4.86,4.15,7.96,9.43,8.95,15.27.57,3.36.43,6.79-.41,10.19-.12.48-.55.8-1.01.8h-.02Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.86,50.74c-.38,0-.73-.2-.91-.53l-1.33-2.34h-3.37c-.58,0-1.05-.47-1.05-1.05s.47-1.05,1.05-1.05h3.99c.38,0,.73.2.91.53l1.33,2.34h68.89c5.7-.24,11.15-1.63,16.16-4.1,5.61-2.77,9.15-6.21,11.06-8.06,3.67-3.56,6.77-7.67,9.19-12.19.27-.51.91-.71,1.42-.43.51.27.71.91.43,1.42-2.53,4.72-5.75,8.99-9.58,12.7-1.99,1.93-5.68,5.51-11.59,8.43-5.27,2.6-11,4.05-17.04,4.32h-69.55Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.8,61.27c-.73,0-1.46-.01-2.18-.04h-64.47c-.58,0-1.05-.47-1.05-1.05s.47-1.05,1.05-1.05h64.51c5.98.22,11.9-.48,17.6-2.09,6.66-1.87,11.45-4.53,13.21-5.58,7.84-4.72,13.95-11.4,16.32-14.6,1.01-1.36,1.91-2.36,3.7-4.36,2.37-2.63,3.18-3.26,4.27-3.72,2.83-1.17,5.57-.24,6.09-.03,3.75,1.43,6.05,5.01,6,9.36,0,.57-.48,1.03-1.05,1.03h-.01c-.58,0-1.04-.48-1.04-1.06.03-3.44-1.75-6.27-4.65-7.37-.24-.09-2.4-.87-4.54.01-.65.27-1.21.61-3.51,3.18-1.75,1.95-2.63,2.93-3.58,4.21-2.46,3.33-8.8,10.26-16.93,15.15-1.83,1.1-6.82,3.86-13.73,5.81-5.22,1.47-10.6,2.2-16.02,2.2h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.43,47.87h-12.44c-.47,0-.88-.31-1.01-.76,0,0-1.9-6.73-2.9-10.29-1.02-3.62-2.36-5.84-3.8-6.25-1.75-.5-4.22.32-4.94,1.31-.62.85-1.24,4.21-1.5,6.32-.07.57-.59.99-1.17.92-.57-.07-.99-.59-.92-1.17.11-.94.73-5.71,1.88-7.3,1.3-1.81,4.74-2.81,7.22-2.1,2.25.64,3.97,3.16,5.25,7.69.8,2.82,2.15,7.66,2.69,9.52h11.65c.58,0,1.05.47,1.05,1.05s-.47,1.05-1.05,1.05h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.25,61.38c-.1,0-.19-.01-.29-.04-.56-.16-.88-.73-.73-1.29.19-.66,1.86-6.5,2.92-8.21,1.25-2.02,4.08-2.88,5.98-2.52,1.49.28,3.28,1.73,4.86,3,.29.23.55.45.8.64l.29.23c1.78,1.4,6.51,5.14,11.27,5.57,5.27.48,20.44.38,20.59.38.57,0,1.04.46,1.05,1.04,0,.58-.46,1.05-1.04,1.06-.63,0-15.43.1-20.8-.39-5.38-.49-10.47-4.5-12.38-6.01l-.28-.22c-.26-.2-.54-.43-.83-.66-1.18-.95-2.96-2.39-3.93-2.57-1.06-.2-3.02.3-3.8,1.57-.76,1.24-2.2,5.96-2.68,7.67-.13.46-.55.76-1.01.76Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.65,70.2h-34.81c-.46,0-.87-.3-1-.73l-2.73-8.76c-.18-.55.14-1.14.69-1.31.55-.17,1.14.14,1.32.69l2.5,8.02h33.26l2.41-8.07c.17-.55.75-.87,1.31-.71.55.17.87.75.71,1.31l-2.62,8.83c-.13.45-.54.75-1.01.75h-.01Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.55,61.23h-42.54c-.52,0-.96-.38-1.04-.9l-2.88-20.38c-.34-2.42.15-4.82,1.38-6.73,1.37-2.13,2.98-2.62,4.09-2.65,3.4-.1,4.28,2.01,4.51,2.91.15.6.31,1.06.52,1.47.77,1.5,1.18,1.95,1.29,2.05,1.08.27,7.05.64,8.23.24.47-.16,1.03-2.01,1.27-2.8.33-1.08.57-1.87,1.04-2.33.87-.85,1.84-1.57,4.17-1.24s4.09,4.47,4.58,5.73c.21.54-.06,1.15-.6,1.36-.54.21-1.15-.06-1.36-.6-.77-1.99-2.18-4.3-2.92-4.41-1.5-.22-1.84.12-2.41.67-.11.15-.33.89-.49,1.43-.52,1.71-1.11,3.65-2.59,4.17-1.81.63-8.65.1-9.68-.26-.52-.18-1.18-.68-2.4-3.06-.28-.55-.5-1.16-.69-1.91-.23-.92-1.06-1.37-2.42-1.33-.88.03-1.69.59-2.39,1.68-.96,1.49-1.34,3.38-1.06,5.3l2.74,19.48h41.63c.58,0,1.05.47,1.05,1.05s-.47,1.05-1.05,1.05h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.29,70.2h-7.65c-.44,0-.84-.28-.99-.69l-2.93-8.19c-.2-.55.09-1.15.64-1.34.55-.2,1.15.09,1.34.64l2.69,7.5h6.91c6.46,0,12.81-1.77,18.34-5.12l.87-.52c3.76-2.27,6.93-5.26,9.43-8.86l9.95-14.37c.33-.48.99-.59,1.46-.27.47.33.59.99.27,1.46l-9.95,14.37c-2.67,3.85-6.05,7.04-10.07,9.46l-.87.52c-5.86,3.54-12.58,5.42-19.43,5.42h0Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.1,61.27h-29.05c-.58,0-1.05-.47-1.05-1.05s.47-1.05,1.05-1.05h29.05c.58,0,1.05.47,1.05,1.05s-.47,1.05-1.05,1.05Z",
    fill: "#234c6f"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.57,103.69H.6v7.14h21.96v-7.14Z",
    fill: "#0090d1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.93,111.18H.26v-7.84h22.66v7.84ZM.96,110.48h21.26v-6.44H.96v6.44Z",
    fill: "#234c6f"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5,103.69h-21.96v7.14h21.96v-7.14Z",
    fill: "#0090d1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M66.86,111.18h-22.66v-7.84h22.66v7.84ZM44.9,110.48h21.26v-6.44h-21.26v6.44Z",
    fill: "#234c6f"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M110.44,103.69h-21.96v7.14h21.96v-7.14Z",
    fill: "#0090d1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M110.8,111.18h-22.66v-7.84h22.66v7.84ZM88.83,110.48h21.26v-6.44h-21.26v6.44Z",
    fill: "#234c6f"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M154.37,103.69h-21.96v7.14h21.96v-7.14Z",
    fill: "#0090d1"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M154.72,111.18h-22.66v-7.84h22.66v7.84ZM132.76,110.48h21.26v-6.44h-21.26v6.44Z",
    fill: "#234c6f"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M198.31,103.69h-21.96v7.14h21.96v-7.14Z",
    fill: "#0090d1"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M198.66,111.18h-22.66v-7.84h22.66v7.84ZM176.69,110.48h21.26v-6.44h-21.26v6.44Z",
    fill: "#234c6f"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M242.24,103.69h-21.96v7.14h21.96v-7.14Z",
    fill: "#0090d1"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M242.59,111.18h-22.66v-7.84h22.66v7.84ZM220.63,110.48h21.26v-6.44h-21.26v6.44Z",
    fill: "#234c6f"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M286.18,103.69h-21.96v7.14h21.96v-7.14Z",
    fill: "#0090d1"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M286.53,111.18h-22.66v-7.84h22.66v7.84ZM264.56,110.48h21.26v-6.44h-21.26v6.44Z",
    fill: "#234c6f"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M330.1,103.69h-21.96v7.14h21.96v-7.14Z",
    fill: "#0090d1"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M330.46,111.18h-22.66v-7.84h22.66v7.84ZM308.5,110.48h21.26v-6.44h-21.26v6.44Z",
    fill: "#234c6f"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M374.04,103.69h-21.96v7.14h21.96v-7.14Z",
    fill: "#0090d1"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M374.4,111.18h-22.66v-7.84h22.66v7.84ZM352.43,110.48h21.26v-6.44h-21.26v6.44Z",
    fill: "#234c6f"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M417.97,103.69h-21.96v7.14h21.96v-7.14Z",
    fill: "#0090d1"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M418.33,111.18h-22.66v-7.84h22.66v7.84ZM396.37,110.48h21.26v-6.44h-21.26v6.44Z",
    fill: "#234c6f"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M461.91,103.69h-21.96v7.14h21.96v-7.14Z",
    fill: "#0090d1"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M462.26,111.18h-22.66v-7.84h22.66v7.84ZM440.29,110.48h21.26v-6.44h-21.26v6.44Z",
    fill: "#234c6f"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M505.84,103.69h-21.96v7.14h21.96v-7.14Z",
    fill: "#0090d1"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M506.19,111.18h-22.66v-7.84h22.66v7.84ZM484.23,110.48h21.26v-6.44h-21.26v6.44Z",
    fill: "#234c6f"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M549.78,103.69h-21.96v7.14h21.96v-7.14Z",
    fill: "#0090d1"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M550.13,111.18h-22.66v-7.84h22.66v7.84ZM528.16,110.48h21.26v-6.44h-21.26v6.44Z",
    fill: "#234c6f"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M593.7,103.69h-21.96v7.14h21.96v-7.14Z",
    fill: "#0090d1"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M594.06,111.18h-22.66v-7.84h22.66v7.84ZM572.1,110.48h21.26v-6.44h-21.26v6.44Z",
    fill: "#234c6f"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M637.64,103.69h-21.96v7.14h21.96v-7.14Z",
    fill: "#0090d1"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M638,111.18h-22.66v-7.84h22.66v7.84ZM616.03,110.48h21.26v-6.44h-21.26v6.44Z",
    fill: "#234c6f"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M642.22,111.39H1.19c-.58,0-1.05-.47-1.05-1.05v-6.72c0-.58.47-1.05,1.05-1.05h641.02c.58,0,1.05.47,1.05,1.05v6.72c0,.28-.11.55-.3.74-.2.2-.46.31-.74.31ZM2.24,109.29h638.93v-4.62H2.24v4.62Z",
    fill: "#234c6f"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M22.57,208.74H.6v7.14h21.96v-7.14Z",
    fill: "#0090d1"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M22.93,216.23H.26v-7.84h22.66v7.84ZM.96,215.53h21.26v-6.44H.96v6.44Z",
    fill: "#234c6f"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5,208.74h-21.96v7.14h21.96v-7.14Z",
    fill: "#0090d1"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M66.86,216.23h-22.66v-7.84h22.66v7.84ZM44.9,215.53h21.26v-6.44h-21.26v6.44Z",
    fill: "#234c6f"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M110.44,208.74h-21.96v7.14h21.96v-7.14Z",
    fill: "#0090d1"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M110.8,216.23h-22.66v-7.84h22.66v7.84ZM88.83,215.53h21.26v-6.44h-21.26v6.44Z",
    fill: "#234c6f"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M154.37,208.74h-21.96v7.14h21.96v-7.14Z",
    fill: "#0090d1"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M154.72,216.23h-22.66v-7.84h22.66v7.84ZM132.76,215.53h21.26v-6.44h-21.26v6.44Z",
    fill: "#234c6f"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M198.31,208.74h-21.96v7.14h21.96v-7.14Z",
    fill: "#0090d1"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M198.66,216.23h-22.66v-7.84h22.66v7.84ZM176.69,215.53h21.26v-6.44h-21.26v6.44Z",
    fill: "#234c6f"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M242.24,208.74h-21.96v7.14h21.96v-7.14Z",
    fill: "#0090d1"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M242.59,216.23h-22.66v-7.84h22.66v7.84ZM220.63,215.53h21.26v-6.44h-21.26v6.44Z",
    fill: "#234c6f"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M286.18,208.74h-21.96v7.14h21.96v-7.14Z",
    fill: "#0090d1"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M286.53,216.23h-22.66v-7.84h22.66v7.84ZM264.56,215.53h21.26v-6.44h-21.26v6.44Z",
    fill: "#234c6f"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M330.1,208.74h-21.96v7.14h21.96v-7.14Z",
    fill: "#0090d1"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M330.46,216.23h-22.66v-7.84h22.66v7.84ZM308.5,215.53h21.26v-6.44h-21.26v6.44Z",
    fill: "#234c6f"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M374.04,208.74h-21.96v7.14h21.96v-7.14Z",
    fill: "#0090d1"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M374.4,216.23h-22.66v-7.84h22.66v7.84ZM352.43,215.53h21.26v-6.44h-21.26v6.44Z",
    fill: "#234c6f"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M417.97,208.74h-21.96v7.14h21.96v-7.14Z",
    fill: "#0090d1"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M418.33,216.23h-22.66v-7.84h22.66v7.84ZM396.37,215.53h21.26v-6.44h-21.26v6.44Z",
    fill: "#234c6f"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M461.91,208.74h-21.96v7.14h21.96v-7.14Z",
    fill: "#0090d1"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M462.26,216.23h-22.66v-7.84h22.66v7.84ZM440.29,215.53h21.26v-6.44h-21.26v6.44Z",
    fill: "#234c6f"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M505.84,208.74h-21.96v7.14h21.96v-7.14Z",
    fill: "#0090d1"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M506.19,216.23h-22.66v-7.84h22.66v7.84ZM484.23,215.53h21.26v-6.44h-21.26v6.44Z",
    fill: "#234c6f"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M549.78,208.74h-21.96v7.14h21.96v-7.14Z",
    fill: "#0090d1"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M550.13,216.23h-22.66v-7.84h22.66v7.84ZM528.16,215.53h21.26v-6.44h-21.26v6.44Z",
    fill: "#234c6f"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M593.7,208.74h-21.96v7.14h21.96v-7.14Z",
    fill: "#0090d1"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M594.06,216.23h-22.66v-7.84h22.66v7.84ZM572.1,215.53h21.26v-6.44h-21.26v6.44Z",
    fill: "#234c6f"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M637.64,208.74h-21.96v7.14h21.96v-7.14Z",
    fill: "#0090d1"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M638,216.23h-22.66v-7.84h22.66v7.84ZM616.03,215.53h21.26v-6.44h-21.26v6.44Z",
    fill: "#234c6f"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M642.22,216.44H1.19c-.58,0-1.05-.47-1.05-1.05v-6.72c0-.58.47-1.05,1.05-1.05h641.02c.58,0,1.05.47,1.05,1.05v6.72c0,.28-.11.54-.3.74-.2.2-.46.31-.74.31ZM2.24,214.35h638.93v-4.62H2.24v4.62Z",
    fill: "#234c6f"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.02,227.69l16.81-10.77",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.28,227.69l16.81-10.77",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.27,227.69l16.8-10.77",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.52,227.69l16.81-10.77",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.77,227.69l16.8-10.77",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.02,227.69l16.81-10.77",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.28,227.69l16.8-10.77",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.53,227.69l16.81-10.77",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.78,227.69l16.8-10.77",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.03,227.69l16.81-10.77",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.28,227.69l16.8-10.77",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.53,227.69l16.81-10.77",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.79,227.69l16.8-10.77",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.04,227.69l16.81-10.77",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.29,227.69l16.8-10.77",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.54,227.69l16.81-10.77",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.81,227.69l16.8-10.77",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.07,227.69l16.81-10.77",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.34,227.69l16.8-10.77",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.61,227.69l16.8-10.77",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.87,227.69l16.8-10.77",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.14,227.69l16.8-10.77",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.4,227.69l16.8-10.77",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.67,227.69l16.8-10.77",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.94,227.69l16.81-10.77",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.21,227.69l16.8-10.77",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.45,227.74l16.81-10.77",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.71,227.74l16.8-10.77",
    fill: "none",
    stroke: "#234c6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M668.88,215.76H.12v12.77h668.76v-12.77Z",
    fill: "#234c6f",
    isolation: "isolate",
    opacity: 0.2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPitchedRoofMajcoat);
export default __webpack_public_path__ + "static/media/pitchedRoof_majcoat.ab6a0c7b1603f821388644e3fe03281b.svg";
export { ForwardRef as ReactComponent };